import globals from '../models/globals';

export function hasDtm(){
    return typeof(_satellite) === 'object' &&
        typeof(_satellite.track) === 'function';
}

export function dtmTrack(newOmn, trackType){
    if(hasDtm()){
        if(typeof(digitalData) === 'undefined'){
            window.digitalData = {};
        }

        window.digitalData.widget = {
            pageName:    newOmn.pagename,
            hierarchy:   newOmn.hierarchy,
            pcn:         newOmn.pcnnumber,
            events:      newOmn.events || '',
            products:    newOmn.products,
            tools:       newOmn.tools,
            eventAction: newOmn.eventAction || '',
            eventAsset:  newOmn.eventAsset || '',
            error:       newOmn.error,
            id:          newOmn.id
        };

        _satellite.track(trackType);
        return true;
    }else{
        return false;
    }
}

export function getDtmHierarchy(market){
    let hierarchy = '';
    try{
        //As per suggestion from tagging team, getting the parent page hierarchy using digitalData from the tagging context.
        if(typeof(_satellite) === 'object' &&
            typeof(digitalData) === 'object' && digitalData &&
            typeof(digitalData.page) === 'object' && digitalData.page &&
            typeof(digitalData.page.category) === 'object' && digitalData.page.category &&
            typeof(digitalData.page.pageInfo) === 'object' && digitalData.page.pageInfo) {

            const country = digitalData.page.pageInfo.country ? digitalData.page.pageInfo.country + "|" : "";
            const businessUnit = digitalData.page.category.businessUnit ? digitalData.page.category.businessUnit + "|" : "";
            const primaryCategory = digitalData.page.category.primaryCategory ? digitalData.page.category.primaryCategory + "|" : "";
            const subCategory1 = digitalData.page.category.subCategory1 ? digitalData.page.category.subCategory1 + "|" : "";
            const subCategory2 = digitalData.page.category.subCategory2 ? digitalData.page.category.subCategory2 + "|" : "";
            const subCategory3 = digitalData.page.category.subCategory3 ? digitalData.page.category.subCategory3 : "";

            hierarchy = `${country}${businessUnit}${primaryCategory}${subCategory1}${subCategory2}${subCategory3}`;

            if (hierarchy.endsWith('|')) {
                hierarchy = hierarchy.slice(0, hierarchy.length - 1);
            }
        }
    } catch(err) {}

    if(!hierarchy){
        hierarchy = market + '|AMEX|Widget|GI'; // default hierarchy
    }
    return hierarchy;
}



// WEBPACK FOOTER //
// ./application/src/utilities/dtm.js